import {Component, OnInit} from '@angular/core';
import {SettingItem} from './setting.model';
import {RolesService} from '../../core/services/roles/roles.service';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {
    public internalAdminSettingsList: SettingItem[] = [
        {id: 2, type: 'base-url', name: 'Base URL'},
        {id: 3, type: 'wasabi-functions', name: 'Wasabi Functions'}
    ];

    public settingsList: SettingItem[] = [
        {id: 1, type: 'timeout', name: 'Timeout Event'},
    ];

    private searchForValue: string;
    public selectedSetting: SettingItem;

    constructor(private rolesService: RolesService) {
    }

    ngOnInit() {
        if (this.rolesService.isInternalAdmin()) {
            this.settingsList = [...this.settingsList, ...this.internalAdminSettingsList];
        }
    }

    selectSetting(setting) {
        this.selectedSetting = setting;
    }

    searchForChange(event) {
        this.searchForValue = event.value;
        // TODO: search functionality
    }
}
